// extracted by mini-css-extract-plugin
module.exports = {"section":"uI","sectionOpen":"vI","cvError":"wI"};